/*
 * simple url redirector component that handles both relative and absolute URLs.
 * react-dom-router wont handle absolutely urls and its possible for some end pages
 * to be custom end page urls.
 */

import React from 'react';
import PropTypes from 'prop-types';

class GoToURL extends React.Component {
  componentDidMount() {
    window.location.replace(this.props.url);
  }

  render() {
    return null;
  }
}

GoToURL.propTypes = {
  url: PropTypes.string.isRequired,
};

export default GoToURL;
